import useSyncProgressStore from "../stores/useSyncProgressStore";
import { trace } from "./debugTrace";

/**
 * During a Full Sync, db.products is cleared synchronously and then
 * repopulated across many awaited paginated batches (can take 10s+ on large
 * catalogs). The background auto-sync timer deliberately runs this without
 * blocking the UI, so a product listing read directly from db.products
 * (bypassing the reactive search index) can land in that empty/partial
 * window and appear to have "no products".
 *
 * Any direct db.products reader that isn't already reactive to sync state
 * should await this first.
 */
export const waitForProductsTableStable = async (maxWaitMs = 20000) => {
  if (!useSyncProgressStore.getState().productsTableSyncing) return;
  const start = Date.now();
  trace("ProductsSync", "reader waiting for products table to stabilize");
  while (useSyncProgressStore.getState().productsTableSyncing && Date.now() - start < maxWaitMs) {
    await new Promise((resolve) => setTimeout(resolve, 200));
  }
  trace("ProductsSync", "reader resumed after wait", {
    waitedMs: Date.now() - start,
    timedOut: useSyncProgressStore.getState().productsTableSyncing,
  });
};
